import CurrencyService, { registerCurrencyServiceAdapters } from '@cubemeet/core/services/currencyService';
import ensureRegistered from './currencyAdaptersWeb';

ensureRegistered();

export const currencyService = new CurrencyService();
export default currencyService;
